import React from 'react';

import { mq } from '@helpers/breakpoints';
import { Box, Heading, Text } from '@rebass/emotion';

import { GatsbyImage } from './index';

const ImageText = ({ imgsrc, children, header }) => {
  return (
    <div
      css={mq({
        display: ['block', 'flex', 'flex'],
        marginTop: ['40px'],
        justifyContent: ['space-between'],
      })}
    >
      <GatsbyImage
        imgsrc={imgsrc}
        css={mq({
          height: ['100%'],
          width: ['70px'],
          display: ['inline-block'],
        })}
      />
      <Box mt={['8%', 0, 0]} width={[1, '70%', '70%']}>
        {header && (
          <Heading mb={3} fontSize={[1, 2, 3]} fontWeight="bold">
            {header}
          </Heading>
        )}
        <Text fontSize={[1, 1, 2]} lineHeight={1.5}>
          {children}
        </Text>
      </Box>
    </div>
  );
};

export default ImageText;
